import { IconCross } from '@xing-com/icons';

import * as Styled from './bottom-sheet.styles';
import type { BottomSheetProps } from './bottom-sheet.types';

export const BottomSheetPrimitive = ({
  children,
  className,
  closeModal,
  show,
  showCloseButton,
  ...props
}: BottomSheetProps): JSX.Element => (
  <Styled.BottomSheet
    className={className}
    data-show={show}
    data-xds="BottomSheet"
    {...props}
  >
    <Styled.Wrapper>
      {children}
      {showCloseButton ? (
        <Styled.Close icon={IconCross} onClick={closeModal} />
      ) : null}
    </Styled.Wrapper>
  </Styled.BottomSheet>
);

BottomSheetPrimitive.displayName = 'BottomSheet (Primitive)';
